
import { all, call, fork, put, takeEvery } from 'redux-saga/effects';
import API, { auth } from '../../constants/api';
import {
    MERCHANT_FETCH,
    MERCHANT_SUMMARY_FETCH
} from '../actions';

import {
    merchantSuccess,
    merchantFail,
    merchantSummarySuccess,
    merchantSummaryFail
} from './actions';

import { sortOrder } from '../../helpers/Utils';

const merchantFetchAsync = async () =>
    await API.get('/merchant', {

    },
    {
      "headers" : auth
    })
        .then(payments => payments)
        .catch(error => error);

function* merchantFetch({ payload }) {

    try {
        const merchantFetch = yield call(merchantFetchAsync);
        console.log("merchantFetch, ",merchantFetch)
        if (merchantFetch.data.StatusCode === "0000") {
            const data = merchantFetch.data.ResultValues.sort(sortOrder('merchant_name'))
            yield put(merchantSuccess(data));
        } else {
            yield put(merchantFail(merchantFetch.data.Message));
        }
    } catch (error) {
        yield put(merchantFail(error));
    }
}

// const merchantSummaryFetchAsync = async () =>
//     await API.get('/merchant', {
//
//     },
//     {
//       "headers" : auth
//     })
//         .then(data => data)
//         .catch(error => error);

function* merchantSummaryFetch({ payload }) {

    try {
        const merchantSummaryFetch = yield call(merchantFetchAsync);
        if (merchantSummaryFetch.data.StatusCode === "0000") {
            const merchantCount = merchantSummaryFetch.data.ResultValues.length
            yield put(merchantSummarySuccess(merchantCount));
        } else {
            yield put(merchantSummaryFail(merchantSummaryFetch.data.Message));
        }
    } catch (error) {
        yield put(merchantSummaryFail(error));
    }
}

export function* watchMerchantFetch() {
    yield takeEvery(MERCHANT_FETCH, merchantFetch);
    yield takeEvery(MERCHANT_SUMMARY_FETCH, merchantSummaryFetch)
}

export default function* rootSaga() {
    yield all([
        fork(watchMerchantFetch),
    ]);
}
